/**
 * Функция для удаления HTML-тегов из строки и извлечения чистого текста.
 * @function stripHtml
 * @param {string} html - Входная строка, содержащая HTML-разметку.
 * @returns {string} Чистый текст без HTML-тегов, с нормализованными пробелами.
 *                  Возвращает пустую строку при серверном рендеринге или если текст отсутствует.
 */
export const stripHtml = (html: string): string => {
  // Проверяем, выполняется ли код на сервере (где window недоступен)
  if (typeof window === "undefined") {
    // Если рендеринг на сервере, возвращаем пустую строку
    return "";
  }

  // Парсим HTML-строку в DOM-документ
  const doc = new DOMParser().parseFromString(html, "text/html");
  // Извлекаем текстовое содержимое тела документа, удаляем начальные/концевые пробелы
  // и заменяем множественные пробелы на одиночные; возвращаем пустую строку, если текста нет
  return doc.body.textContent?.trim().replace(/\s+/g, " ") || "";
};
